/* Mon Chou FAQ - 3.81 (Claude, 2026-10-18)
   Category pills (tabs) + PDP-style accordion for sections/adev-faq.liquid.
   Replaces adev-faq.min.js. Deep links: /pages/faq#levering opens that
   category; #<question-block-id> opens that question. */
(function () {
  'use strict';
  function slug(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/æ/g, 'ae').replace(/ø/g, 'o').replace(/å/g, 'a').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function init(root) {
    if (!root || root.getAttribute('data-mc-faq')) return;
    root.setAttribute('data-mc-faq', '1');
    var tabs = [].slice.call(root.querySelectorAll('.faq__tab'));
    var panels = [].slice.call(root.querySelectorAll('.faq__panel'));

    function show(id, focus) {
      var tab = null;
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-faq-tab') === id;
        t.classList.toggle('active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        if (on) tab = t;
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-faq-panel') === id || p.getAttribute('data-faq-panel') === 'always';
        var was = p.classList.contains('active');
        p.classList.toggle('active', on);
        if (on && !was) {
          p.classList.remove('mc-faq-in'); void p.offsetWidth; p.classList.add('mc-faq-in');
        }
      });
      if (focus && tab) tab.focus();
    }
    function toggleItem(item, open) {
      var on = typeof open === 'boolean' ? open : !item.classList.contains('active');
      item.classList.toggle('active', on);
      var b = item.querySelector('.faq__item-header');
      if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(t.getAttribute('data-faq-tab')); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
        else if (k === 'ArrowLeft' || k === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (k === 'Home') n = tabs[0];
        else if (k === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); show(n.getAttribute('data-faq-tab'), true); }
      });
    });
    root.addEventListener('click', function (e) {
      var h = e.target.closest && e.target.closest('.faq__item-header');
      if (!h || !root.contains(h)) return;
      toggleItem(h.closest('.faq__item'));
    });

    // deep link: #<category name> or #<question id>
    function fromHash() {
      var h = decodeURIComponent((location.hash || '').slice(1));
      if (!h) return;
      var item = root.querySelector('.faq__item[id="' + h.replace(/"/g, '') + '"]');
      if (item) {
        var p = item.closest('.faq__panel');
        if (p) show(p.getAttribute('data-faq-panel'));
        toggleItem(item, true);
        return;
      }
      tabs.forEach(function (t) { if (slug(t.textContent) === slug(h)) show(t.getAttribute('data-faq-tab')); });
    }
    fromHash();
    window.addEventListener('hashchange', fromHash);

    // theme editor: selecting a block shows it
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        var el = e.target;
        if (!root.contains(el)) return;
        if (el.classList.contains('faq__item')) {
          var p = el.closest('.faq__panel'); if (p) show(p.getAttribute('data-faq-panel'));
          toggleItem(el, true);
        } else if (el.classList.contains('faq__category')) {
          var p2 = el.closest('.faq__panel'); if (p2) show(p2.getAttribute('data-faq-panel'));
        }
      });
    }
  }
  function boot() { [].forEach.call(document.querySelectorAll('.main-faq[data-faq-root]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    [].forEach.call(e.target.querySelectorAll('.main-faq[data-faq-root]'), init);
  });
})();
